import { render, staticRenderFns } from "./CardManufacturing.vue?vue&type=template&id=93cdaf98&scoped=true&"
import script from "./CardManufacturing.vue?vue&type=script&lang=js&"
export * from "./CardManufacturing.vue?vue&type=script&lang=js&"
import style0 from "./CardManufacturing.vue?vue&type=style&index=0&id=93cdaf98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93cdaf98",
  null
  
)

export default component.exports